import { useSelector } from "react-redux";
import CartProductCard from "./CartProductCard";
import downAngle from "resources/img/puffu/downAngle.png";
import upAngle from "resources/img/puffu/upAngle.png";
import style from "./CartList.module.css";
import P from "components/P";
import Center from "layouts/wrapper/Center";
import { useEffect, useRef, useState } from "react";
import addCartIcon from "resources/img/puffu/addCart.png";
import Dummy from "components/Dummy";
import PromotionGroupCard from "../card/PromotionGroupCard";
import categorySound from "resources/music/물방울.mp3";
import signUpSound from "resources/music/수빈.mp3";
import btnSound from "resources/music/button-pressed-38129.mp3";

function CartList() {
    const cartData = useSelector((state) => state.cart.products);
    const listRef = useRef(null);
    const prevCartDataLength = useRef(cartData.length);
    const [canScrollUp, setCanScrollUp] = useState(false);
    const [canScrollDown, setCanScrollDown] = useState(false);
    const audioRef = useRef();


    useEffect(() => {
        if (listRef.current) {
            if (cartData.length > prevCartDataLength.current) {
                // 새로운 상품이 추가되었을 때 스크롤을 맨 아래로 이동
                listRef.current.scrollTop = listRef.current.scrollHeight;
            }
            // 이전 카트 데이터 길이를 현재 길이로 업데이트
            prevCartDataLength.current = cartData.length;
        }
    }, [cartData]);

    useEffect(() => {
        const handleScroll = () => {
            if (listRef.current) {
                setCanScrollUp(listRef.current.scrollTop > 0);
                setCanScrollDown(
                    listRef.current.scrollHeight - listRef.current.scrollTop >
                    listRef.current.clientHeight
                );
            }
        };

        const refCurrent = listRef.current;
        if (refCurrent) {
            refCurrent.addEventListener('scroll', handleScroll);
            handleScroll(); // 초기 상태 업데이트
        }

        return () => {
            if (refCurrent) {
                refCurrent.removeEventListener('scroll', handleScroll);
            }
        };
    }, []);

    const handleUpClick = () => {
        if (listRef.current) {
            listRef.current.scrollBy({ top: -173 });
            audioRef.current.play();

        }
    };

    const handleDownClick = () => {
        if (listRef.current) {
            listRef.current.scrollBy({ top: 173 });
            audioRef.current.play();

        }
    };

        // 프로모션 상품들을 그룹화하는 함수
        const groupPromotionProducts = (products) => {
            const groupedProducts = [];
            const promotionGroups = new Map();
    
            products.forEach(product => {
                if (product.isPromotionProduct && product.promotionId) {
                    if (!promotionGroups.has(product.promotionId)) {
                        promotionGroups.set(product.promotionId, {
                            id: product.promotionId,
                            products: [],
                            totalPrice: 0,
                            exhibitionName: product.exhibitionName,
                            discountRate: product.discountRate,
                            totalOriginalPrice: 0
                        });
                    }
                    const group = promotionGroups.get(product.promotionId);
                    group.products.push(product);
                    group.totalPrice += product.price * product.quantity;
                    group.totalOriginalPrice += product.originalPrice * product.quantity;
                } else {
                    groupedProducts.push(product);
                }
            });
    
            promotionGroups.forEach(group => {
                groupedProducts.push({
                    id: group.id,
                    isPromotionGroup: true,
                    exhibitionName: group.exhibitionName,
                    products: group.products,
                    totalPrice: group.totalPrice,
                    totalOriginalPrice: group.totalOriginalPrice,
                    discountRate: group.discountRate
                });
            });
    
            return groupedProducts;
        };

        const groupedCartData = groupPromotionProducts(cartData);


    return (
        <div className={style.wrap}>
                        <audio ref={audioRef} src={categorySound} preload="auto" />
            <div className={style.upAngle} onClick={handleUpClick} style={{ opacity: canScrollUp ? 1 : 0.3 }}>
                <img src={upAngle} width={"30px"} />
            </div>
            <div
                ref={listRef}
                style={{
                    overflowX: "visible",
                    overflowY: 'scroll',
                    height: "599px",
                    backgroundColor: "white",
                    maxHeight: '599px',
                    touchAction: "pan-y",
                    width: "93%"
                }}
            >
                {
                    groupedCartData.length > 0 ? (
                        groupedCartData.map((data, index) => {
                            return data.isPromotionGroup ? 
                                <PromotionGroupCard key={index} item={data} /> : 
                                <CartProductCard key={index} data={data} />;
                        })
                    ) : (
                        <div style={{ height: "25vh", display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "column" }}>
                            <img src={addCartIcon} width={"80px"} alt="cart" />
                            <Dummy height={"15px"} />
                            <P font={"Pretendard"} weight={700} size={18} color={"rgba(255, 203, 174, 1)"}>상품을 담아주세요</P>
                        </div>
                    )
                }
            </div>
            <div className={style.downAngle} onClick={handleDownClick} style={{ opacity: canScrollDown ? 1 : 0.3 }}>
                <img src={downAngle} width={"30px"} />
            </div>
        </div>
    );
}

export default CartList;